import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../images/logo/resizelogo.png";
import "../Component/newHeader.css";

const NewHeader = () => {
    const [categoryOpen, setCategoryOpen] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);

    const location = useLocation();
    const categoryRef = useRef(null);

    const categories = [
        { name: "Whole & Ground Spices", icon: "", path: "/ProductList" },
        { name: "Ayurvedic Herbs & Roots", icon: "", path: "/ProductList" },
        { name: "Organic Staples & Grains", icon: "", path: "/ProductList" },
    ];

    const navLinks = [
        { name: "Home", path: "/Home/" },
        { name: "Products", path: "/ProductList" },
        // { name: "Stores", path: "/StoreList" },
        { name: "About Us", path: "/AboutUs" },
        // { name: "Blog", path: "/Blog" },
        { name: "Contact Us", path: "/Contact" },
    ];

    useEffect(() => {
        setMobileOpen(false);
        setCategoryOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (
                categoryRef.current &&
                !categoryRef.current.contains(event.target)
            ) {
                setCategoryOpen(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const isActive = (path) => {
        if (path === "/Home/") {
            return location.pathname === "/Home/" ||
                location.pathname === "/Home";
        }

        if (path === "/Shop") {
            return location.pathname.startsWith("/Shop") ||
                location.pathname === "/ProductList";
        }

        return location.pathname === path ||
            location.pathname.startsWith(`${path}/`);
    };

    return (
        <header className="kv-header">
            <nav className="kv-navbar">
                <div className="kv-container">

                    {/* Logo and Brand */}
                    <Link to="/Home/" className="kv-brand">
                        <img
                            src={logo}
                            alt="KunjVeda Logo"
                            className="kv-logo"
                        />

                        <span className="kv-brand-text">
                            <span className="kv-brand-name">
                                Kunj<span>Veda</span>
                            </span>
                            <span className="kv-brand-tagline">
                                <b>Purity of Nature, Powder Of Veda.</b>
                            </span>
                        </span>
                    </Link>

                    {/* Mobile Menu Toggle */}
                    <button
                        type="button"
                        className={`kv-menu-toggle ${mobileOpen ? "is-open" : ""
                            }`}
                        onClick={() => setMobileOpen((prev) => !prev)}
                        aria-label={mobileOpen ? "Close navigation" : "Open navigation"}
                        aria-expanded={mobileOpen}
                        aria-controls="kv-navigation"
                    >
                        <span />
                        <span />
                        <span />
                    </button>

                    {/* Navigation */}
                    <div
                        id="kv-navigation"
                        className={`kv-navigation ${mobileOpen ? "is-open" : ""
                            }`}
                    >
                        {/* Main Navigation Links */}
                        <ul className="kv-nav-links">
                            {navLinks.map((item) => (
                                <li key={item.name}>
                                    <Link
                                        to={item.path}
                                        className={`kv-nav-link ${isActive(item.path) ? "active" : ""
                                            }`}
                                        aria-current={
                                            isActive(item.path) ? "page" : undefined
                                        }
                                        onClick={() => setMobileOpen(false)}
                                    >
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                        {/* Categories Dropdown */}
                        <div
                            className="kv-category-wrapper"
                            ref={categoryRef}
                        >
                            <button
                                type="button"
                                className={`kv-category-btn ${categoryOpen ? "active" : ""
                                    }`}
                                onClick={() => setCategoryOpen((prev) => !prev)}
                                aria-expanded={categoryOpen}
                            >
                                <i className="bi bi-grid-fill" />
                                <span>Buy Spices Online </span>
                                <i
                                    className={`bi bi-chevron-down kv-chevron ${categoryOpen ? "rotated" : ""
                                        }`}
                                />
                            </button>

                            {categoryOpen && (
                                <div className="kv-category-menu">
                                    <div className="kv-dropdown-heading">
                                        <span>Explore Collections</span>
                                        <small>Natural goodness for everyday living</small>
                                    </div>

                                    {categories.map((category) => (
                                        <Link
                                            key={category.name}
                                            to={category.path}
                                            className="kv-category-item"
                                            onClick={() => {
                                                setCategoryOpen(false);
                                                setMobileOpen(false);
                                            }}
                                        >
                                            <span className="kv-category-icon">
                                                {/* {category.icon} */}
                                            </span>
                                            <span>{category.name}</span>
                                            <i className="bi bi-arrow-up-right" />
                                        </Link>
                                    ))}

                                    <Link
                                        to="/ProductList"
                                        className="kv-view-all"
                                        onClick={() => {
                                            setCategoryOpen(false);
                                            setMobileOpen(false);
                                        }}
                                    >
                                        View All Products
                                        <i className="bi bi-arrow-right" />
                                    </Link>
                                </div>
                            )}
                        </div>


                    </div>
                </div>
            </nav>
        </header>
    );
};

export default NewHeader;
export { NewHeader };